import WfAffectListContentController from '~/components/wf/affect/list-content/wf-affect-list-content.controller';

export default class WfAffectListHistoryController extends WfAffectListContentController {
	/**
	 * @param {any} affect
	 */
	toggleSelection(affect) {
		const index = this.selected.findIndex(c => c.kid === affect.kid);

		if (index > -1) {
			this.selected.splice(index, 1);
		}
		else {
			this.selected.push(affect);
		}
	}
}
